import 'foundation-sites';

$(document).foundation();

